import { Box } from '@material-ui/core'
import React from 'react'
import NotFoundIcon from '../../../shared/icons/not_found_icon'
import MainLayout from '../../../shared/layout/main-layout/MainLayout'
import buildStyles from './styles'

const Error = () => {
  const styles = buildStyles()

  return (
    <>
      <MainLayout centeredRightSide onlyError>
        <Box
          display="flex"
          height="100%"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <NotFoundIcon />
          <div className={styles.line}>
            <span className={styles.firstLine1}>{`Ups...  `}</span>
            <span className={styles.firstLine2}>coś poszło nie tak :(</span>
          </div>
          <div>
            <span className={styles.secondLine}>Spróbuj ponownie.</span>
          </div>
        </Box>
      </MainLayout>
    </>
  )
}

export default Error
